import {
  innerHighlightedIcon,
  multiDimensionIcon,
  outerHighlightedIcon,
} from './styles/DataPointShape.sty.js';

/** @internal */
export interface MultiDataPointShapeProps {
  active?: boolean;
  color: string;
}

/** @internal */
export const MultiDataPointShape = ({
  color,
  active = false,
}: MultiDataPointShapeProps) => {
  return active ? (
    <span className={outerHighlightedIcon({ singleLine: false })}>
      <span
        style={{ backgroundColor: color }}
        className={innerHighlightedIcon({ singleLine: false })}
      />
    </span>
  ) : (
    <span style={{ backgroundColor: color }} className={multiDimensionIcon} />
  );
};

MultiDataPointShape['displayName'] = 'MultiDataPointShape';
